import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AB8D0574-712C-4403-A5A5-51E16C081605
 * name circle-medium
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-medium.svg
 * tags
 */
export const CircleMediumIcon = createSvgIcon(<><path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z" /></>, 'CircleMediumIcon');
export default CircleMediumIcon